<template>
    <div class="layout-container table-special">
        <el-tabs type="border-card">
            <el-tab-pane label="资讯模板列表">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="'show'">
                        <div class="search-condition">
                            <span class="label">模板名称</span>
                            <div class="input-condition">
                                <el-input v-model="condition.name" maxlength="30" placeholder="请输入关键词查询"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label" >类型</span>
                            <div class="input-condition" >
                                <el-select v-model="condition.type_id" placeholder="全部">
                                    <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" ></el-option>
                                </el-select>
                            </div>
                        </div>
                       
                        <div class="search-condition search-condition-time" style="min-width: 400px;">
                            <span class="label">添加时间</span>
                            <div class="input-condition">
                                <el-date-picker
                                        v-model="condition.time"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        align="right"
                                        value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                                        @change="condition.timestamp = ''"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label" >审核状态</span>
                            <div class="input-condition" >
                                <el-select v-model="condition.status" placeholder="全部">
                                    <el-option  key="0" label="未审核" value="0" ></el-option>
                                    <el-option  key="1" label="已审核" value="1" ></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                        <el-button
                            type="primary"
                            icon="el-icon-plus"
                            @click="handleAdd()"
                            v-permission="'operating.news-model-manage.template-list.create'"
                            >新增模板</el-button>
                    </div>
                </div>
            <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
                    class="list-table"
            >
                <el-table-column  label="ID" prop="id"  width="60px" align="center"></el-table-column>
                <el-table-column  label="模板名称" prop="name" align="center" width="200px"></el-table-column>
                <el-table-column  label="文章类型" prop="type_name"  align="center"></el-table-column>
                <el-table-column  label="文章标题" prop="title"  align="center" width="200px">
                      <template slot-scope="scope">
                        <p class="ellips2" :title="scope.row.title">{{scope.row.title}}</p>
                    </template>
                </el-table-column>
                <el-table-column  label="插入楼盘数"  width="120px" prop="houses_num"  align="center"></el-table-column>
                <el-table-column  label="添加人" prop="creator"  align="center"></el-table-column>
                <el-table-column  label="添加时间" prop="created_at"  align="center" width="200px" ></el-table-column>
                <el-table-column  label="审核状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">未审核</span>
                        <span v-if="scope.row.status == 1">已审核</span>
                    </template>
                </el-table-column>
                <el-table-column  label="资讯生成数量" prop="news_sum"  align="center" width="120px"></el-table-column>
                <el-table-column  label="资讯生成记录" align="center" width="120px">
                    <template slot-scope="scope">
                        <el-button  size="mini" @click="getRecord(scope.row.id)"
                            v-permission="'operating.news-model-manage.template-list'"
                            >查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作"  fixed="right"  width="350px">
                    <template slot-scope="scope">
                        <a class="scan" v-if="scope.row.url" :href="scope.row.url" target="_blank" style="text-decoration:none;cursor: pointer;">预览</a>
                        <el-button v-permission="'operating.news-model-manage.template-list.edit'" size="mini" @click="openEdit(scope.row.id)"
                            >编辑</el-button>
                        <el-button v-if="scope.row.status !=1" v-permission="'operating.news-model-manage.template-list.approve-status'" size="mini" @click="changeStatus(scope.row.id)"
                        >审核</el-button>
                        <el-button v-if="scope.row.status == 1" v-permission="'operating.news-model-manage.template-list.create-news'" size="mini" @click="createNews(scope.row)"
                            >生成文章</el-button>
                        <el-button v-permission="'operating.news-model-manage.template-list.delete'" size="mini" @click="handleDelete(scope.row.id)"
                            >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
             <template v-if="list.length > 0">
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :current-page="condition.page"
                    :total="condition.total"
                    :page-size="condition.per_page"
                    @current-change="currentChange"
                ></el-pagination>
            </template>
        </el-tab-pane>
    </el-tabs>
    <create-news ref="createNews" :callback ="initData" ></create-news>
    <record-list ref="recordList"></record-list>
    </div>
</template>
<style>
    td a:link{
        color: #606266;
    }
    td a:visited{
        color: #606266;
    }
</style>
<script>
    import {getNewsModelList,deleteNewsModel,getNewsModelScan,changeStatus} from '@/service/newsModel'
    import { getSite} from "@/service/site";
    import { NEWS_MODEL } from "@/config/index";
    import createNews from "./component/createNews";
    import recordList from "./component/recordList";

    export default {
        name: "List",
        components: {
           createNews,
           recordList
        },
        data () {
            return {
                typeList:[],
                list: [],
                condition: {
                    type_id: '',
                    name:'',
                    time:'',
                    total: 0,
                    per_page: 10,
                    page: 1,
                    status:''
                },
                siteAll:[],
                isLoading: false,
               
            }
        },
        mounted () {
            this.typeList = NEWS_MODEL.news_types;
            this.initData();
            this.getSiteList()
        },
        methods: {

            handleSearch() {
                this.condition.page=1
                this.initData();
            },
            resetSearch() {
                this.condition = {
                    type_id: '',
                    name:'',
                    time:'',
                    total: 0,
                    per_page: 10,
                    page: 1,
                    status:''
                }
                this.initData();
            },
            handleAdd() {
                this.$router.push({path:'add'});
            },
            openEdit(id) {
                this.$router.push({path: 'add', query: {id:id}})
            },
            currentChange(index) {
                this.condition.page = index;
                this.initData();
            },
            async getSiteList() {
                await getSite({ owned:1, agent_status: 0, per_page: 1000 }).then((data) => {
                    this.siteAll = data.data;
                });
              
            },
            async initData() {
                this.list=[]
                if(this.condition.time && this.condition.time.length>1) {
                    this.condition.updated_at_start= this.condition.time[0]
                    this.condition.updated_at_end = this.condition.time[1]
                }else{
                    delete this.condition.updated_at_start;
                    delete this.condition.updated_at_end;
                }
                await getNewsModelList(this.condition).then((data) => {
                    this.condition.total=data.total
                    let siteurl = window.serverConfig[window.siteMap[domain]].VUE_APP_HOST.substring(14);
                    let url = "https://cs."+siteurl+'/zixun/preview/';
                    data.data.forEach((item,index)=>{
                        data.data[index].url =url+item.id+'.html';
                    })
                    this.list = data.data
                })

               
                //数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            handleDelete(id) {
                this.$confirm("请确认是否删除该模板？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    deleteNewsModel(id)
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "删除成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "删除失败"
                        });
                    });
                });
            },
            changeStatus(id){
                this.$confirm("审核后才可使用模板生成文章，是否修改该模板的审核状态为已审核？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    changeStatus(id)
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "审核成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "审核失败"
                        });
                    });
                });
            },
            createNews(row){
                this.$refs.createNews &&
                (this.$refs.createNews.siteList = this.siteAll)
                && this.$refs.createNews.open(row)
            },
            async goScan(id){
                await getNewsModelScan(id).then((data) => {
                    // this.condition.total=data.total
                    // this.list = data.data
                })
            },
            getRecord(id){
                this.$refs.recordList
                && this.$refs.recordList.open(id);
            },
        }
    }
</script>

<style >
.list-table {
    padding: 0 20px;
    box-sizing: border-box;
}
.baikeCat .el-select{
    width:48%;
    float:left;
}
.v-modal{
    z-index: 2000!important;
}
.el-table .cell a.scan{
    padding: 0px 15px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    margin-right: 10px;
    line-height: 26px;
    display: inline-block;
}
.el-table .cell a.scan:hover{
    color: #409EFF;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}
.ellips2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    max-height:45px;
}
</style>



















